<template>
  <div class="general-background">
    <UserListener
      v-if="activateUserListener"
      collection="users"
      :userID="userID"
      @user-real-time="userRealTime"
    />
    <div>
      <b-navbar variant="faded" style="background-color: black!important;">
        <img
          src="./assets/menu_icon.svg"
          class="d-inline-block align-top"
          v-b-toggle.sidebar-1
          style="height: 40px; margin-right: 10px;"
          alt="menu-icon"
        />
        <img
          src="../assets/img/logo_word_white.png"
          class="d-inline-block align-top"
          v-b-toggle.sidebar-1
          style="height: 40px; margin-right: auto; margin-left: auto;"
          alt="logo-header"
        />
      </b-navbar>
    </div>
    <template v-if="userJSON.id">
      <router-view :userJSON="userJSON" />
    </template>
    <Menu />
  </div>
</template>

<script>
import Vue from "vue";
import VueSwal from "vue-swal";

import Menu from "@/layout/components/Menu.vue";
import UserListener from "@/connection/UserListener.vue";
import { functionsDB } from "@/connection/connection.js";

Vue.use(VueSwal);

export default {
  name: "Layout",
  components: {
    Menu,
    UserListener
  },
  data() {
    return {
      userID: "",
      userJSON: {},
      activateUserListener: false
    };
  },
  methods: {
    userRealTime(userJson) {
      this.userJSON = userJson;
    }
  },
  async mounted() {
    var self = this;
    var authentication = await functionsDB.userAuthentication();
    /*
    // default language
    var navLanguage = navigator.language;
    if (navLanguage.substring(0, 2) == "es") this.translate("esp");
    else this.translate("eng");
    
    // Payment notifications
    var state = this.$route.query.state;
    if (state == "success") {
      this.alertPaySuccess();
    }
    if (state == "cancel") {
      this.alertPayCancel();
    }*/
    // Authetication
    this.userID = authentication.userID;
    switch (authentication.loginInfo) {
      case "existing user":
        this.activateUserListener = true;
        break;
      case "new user":
        this.$swal({
          title: "Welcome!",
          text: "If any questions, please visit our support section.",
          icon: "success"
        });
        this.activateUserListener = true;
        break;
      case "signed out":
        this.$router.push({ path: "/" });
        break;
      default:
        this.$swal({
          title: "Something went wrong!",
          text: "Please refresh the web browser",
          icon: "error"
        });
        break;
    }
  }
};
</script>

<style scoped>
@font-face {
  font-family: cerebriSansBold;
  src: url("../assets/fonts/Cerebri-Sans/CerebriSans-Bold.ttf");
}
@font-face {
  font-family: cerebriSansReg;
  src: url("../assets/fonts/Cerebri-Sans/CerebriSans-Regular.ttf");
}

.general-background {
  background-color: #f9fbfd;
  height: 100%;
  width: 100%;
}
</style>